import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // Route based on who signed in — NOT a hardcoded admin path.
        // Owner (is_admin=true) lands on /admin/dashboard; every other
        // customer lands wherever the Emergent redirect brought them, and
        // is bounced to home if that URL was inside the /admin area.
        const path = location.pathname || "/";
        const goingAdmin = path.startsWith("/admin");
        const target = goingAdmin
          ? (data.is_admin ? "/admin/dashboard" : "/")
          : path;
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: data } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-espresso-light label-xs">
      Signing you in…
    </div>
  );
}
